export default __webpack_public_path__ + "75ad9a279eb1898557fe2b0a20b18a9c.svg";